import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Input } from "semantic-ui-react";

import "components/UploadImage/UploadImage.scss";
import { useUploadImage } from "lib/Form/components/FormUploadImage/hooks";
import { UploadFilePreview } from "lib/Form/components/FormUploadImage/UploadFilePreview";

import type { FieldValues, Path } from "react-hook-form";

type ShallowPath<T> = keyof T & string;

interface UploadImageProps<T extends FieldValues> {
  name: ShallowPath<T>;
  path: string;
  baseUrl: string;
  fileFieldName?: string;
  formFieldProps?: React.HTMLAttributes<HTMLDivElement>;
  onSuccess?: (url: string) => void;
  onError?: (reason: string) => void;
}

export const FormUploadImage = <T extends FieldValues>({ name, path, onSuccess, onError, baseUrl, fileFieldName = name, formFieldProps }: UploadImageProps<T>) => {
  const { t } = useTranslation();
  const methods = useFormContext<T>();
  const { watch } = useFormContext();

  const { handleChangeFile, handleDelete, handleUpload } = useUploadImage<T>({ baseUrl, path });
  const image = watch(name);

  return (
    <Controller
      name={name as Path<T>}
      {...methods}
      render={({ field, fieldState }) => {
        return (
          <div className="upload-container" {...formFieldProps}>
            <div className="UploadImage new">
              <div className="button" onClick={() => handleUpload(name)}>
                <p className="btn-text">{t("v8_choose_file", "Choose File")}</p>
              </div>
              <p className="fileInput-ellipsis">{t(name) || t("v8_choose_file", "Choose File")}</p>
            </div>
            <Input
              id={name}
              accept="image/png, image/gif, image/jpeg"
              type="file"
              style={{ display: "none" }}
              onChange={e => handleChangeFile(e, fileFieldName, field, onSuccess, onError)}
            />
            <UploadFilePreview image={image} onDelete={() => handleDelete(field)} />
            {fieldState.invalid && <div className="error">{t("v8_something_went_wrong")}</div>}
          </div>
        );
      }}
    />
  );
};
